import React, { useEffect, useState } from "react";
import "../css/Qualification.css";
import { LiaSchoolSolid } from "react-icons/lia";
import { IoSchoolSharp } from "react-icons/io5";
import { FaHandsHelping } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { SlCalender } from "react-icons/sl";
import colorSharp from "../assets/img/color-sharp-yellow.png";
import colorSharp2 from "../assets/img/color-sharp2-yellow.png";
import { LiaCertificateSolid } from "react-icons/lia";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import DisplayImageSlider from "./DisplayImageSlider";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);
  const toggleTab = (index) => {
    setToggleState(index);
  };
  const [educationItems, setEducationItems] = useState([]);


  const experienceData = {
    position: "Software Engineer - Intern (Mobile)",
    company: "Silverline IT (PVT) LTD",
    duration: "2025 January - 2025 June",
    projects: [
      {
        name: "Brain Bounce App",
        description: "Designed and developed a Flutter-based app for children with learning disabilities, integrating Firebase backend and ML models for personalized support."
      },
      {
        name: "Tea Farming Assistant App",
        description: "Built a Flutter mobile app leveraging image processing and ML to predict fertilizers, estimate yield, and detect plant diseases, with Firebase backend integration."
      },
      {
        name: "Mobile Security App",
        description: "Developed a Flutter app with real-time facial, voice, and behavioral authentication features, integrating Firebase and advanced ML models."
      },
      {
        name: "AI-Powered Delivery App",
        description: "Enhanced a delivery app with AI/ML features for route optimization, performance analysis, time prediction, and voice-based customer feedback using Flutter and Firebase."
      }
    ]
  };

  async function fetchEducations() {
    try {
      const projectRef = collection(db, "educations");
      const q = query(projectRef);
      const querySnap = await getDocs(q);
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setEducationItems(projects);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchEducations();
  }, []);

  const [courseItems, setCourseItems] = useState([]);

  async function fetchCourses() {
    try {
      const projectRef = collection(db, "courses");
      const q = query(projectRef, orderBy("courseYear", "asc"));
      const querySnap = await getDocs(q);
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setCourseItems(projects);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchCourses();
  }, []);

  const [volunteeringItems, setVolunteeringItems] = useState([]);

  async function fetchVolunteering() {
    try {
      const projectRef = collection(db, "volunteering");
      const q = query(projectRef, orderBy("volunteeringYear", "desc"));
      const querySnap = await getDocs(q);
      let volunteering = [];
      querySnap.forEach((doc) => {
        volunteering.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setVolunteeringItems(volunteering);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchVolunteering();
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [selectedImages, setSelectedImages] = useState([]);
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleImageClick = (images) => {
    setSelectedImages(images);
    setOpenFullScreenImage(true);
  };

  return (
    <section className="qualification section" id="qualification">
      <div className="container">
        <div className="col-12">
          <div className="skill-bx wow zoomIn">
            <div className="about-section">
              <h1 className="background-text-qualification">QUALIFICATIONS</h1>
              <h1 className="foreground-text-qualification" style={{ fontWeight: "800" }}>
                QUALIFICATIONS
                <div className="underline-qualification"></div>
              </h1>
            </div>

            <div className="qualification_tabs">
              {isMobile ? (
                <>
                  <div
                    className={
                      toggleState === 1
                        ? "qualification_button qualification_active button--flex qualification-selection-btn mobile-tab"
                        : "qualification_button button--flex qualification-selection-btn mobile-tab"
                    }
                    onClick={() => toggleTab(1)}
                  >
                    Experience
                    <MdWork style={{ fontSize: "30px", marginLeft: "10px" }} />
                  </div>
                  <div
                    className={
                      toggleState === 2
                        ? "qualification_button qualification_active button--flex qualification-selection-btn mobile-tab"
                        : "qualification_button button--flex qualification-selection-btn mobile-tab"
                    }
                    onClick={() => toggleTab(2)}
                  >
                    Educations
                    <IoSchoolSharp style={{ fontSize: "30px", marginLeft: "10px" }} />
                  </div>
                  <div
                    className={
                      toggleState === 3
                        ? "qualification_button qualification_active button--flex qualification-selection-btn mobile-tab"
                        : "qualification_button button--flex qualification-selection-btn mobile-tab"
                    }
                    onClick={() => toggleTab(3)}
                  >
                    Courses
                    <LiaSchoolSolid style={{ fontSize: "30px", marginRight: "10px" }} />
                  </div>
                  <div
                    className={
                      toggleState === 4
                        ? "qualification_button qualification_active button--flex qualification-selection-btn mobile-tab"
                        : "qualification_button button--flex qualification-selection-btn mobile-tab"
                    }
                    onClick={() => toggleTab(4)}
                  >
                    Volunteering
                    <FaHandsHelping style={{ fontSize: "30px", marginLeft: "10px" }} />
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={
                      toggleState === 1
                        ? "qualification_button qualification_active button--flex qualification-selection-btn"
                        : "qualification_button button--flex qualification-selection-btn"
                    }
                    onClick={() => toggleTab(1)}
                  >
                    <MdWork style={{ fontSize: "40px", marginRight: "10px" }} />
                    Experience
                  </div>
                  <div
                    className={
                      toggleState === 2
                        ? "qualification_button qualification_active button--flex qualification-selection-btn"
                        : "qualification_button button--flex qualification-selection-btn"
                    }
                    onClick={() => toggleTab(2)}
                  >
                    <IoSchoolSharp style={{ fontSize: "40px", marginRight: "10px" }} />
                    Educations
                  </div>
                  <div
                    className={
                      toggleState === 3
                        ? "qualification_button qualification_active button--flex qualification-selection-btn"
                        : "qualification_button button--flex qualification-selection-btn"
                    }
                    onClick={() => toggleTab(3)}
                  >
                    Courses
                    <LiaSchoolSolid style={{ fontSize: "40px", marginLeft: "10px" }} />
                  </div>
                  <div
                    className={
                      toggleState === 4
                        ? "qualification_button qualification_active button--flex qualification-selection-btn"
                        : "qualification_button button--flex qualification-selection-btn"
                    }
                    onClick={() => toggleTab(4)}
                  >
                    Volunteering
                    <FaHandsHelping style={{ fontSize: "40px", marginLeft: "10px" }} />
                  </div>
                </>
              )}
            </div>

            <div className="qualification_sections">

              {/* Experience Section */}
              <div
                className={
                  toggleState === 1
                    ? "qualification_content qualification_content-active"
                    : "qualification_content"
                }
              >
                <div style={{
                  padding: '20px 0',
                  width: '100%'
                }}>
                  {/* Company Header - No Container */}
                  <div style={{
                    textAlign: 'center',
                    marginBottom: '50px',
                    position: 'relative'
                  }}>
                    <div style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '15px',
                      background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                      borderRadius: '50%',
                      width: '80px',
                      height: '80px',
                      boxShadow: '0 10px 30px rgba(255, 165, 0, 0.3)'
                    }}>
                      <HiOutlineOfficeBuilding style={{ fontSize: '40px', color: 'white' }} />
                    </div>

                    <h2 style={{
                      fontSize: isMobile ? '22px' : '32px',
                      fontWeight: '800',
                      marginBottom: '8px',
                      background: 'linear-gradient(45deg, #FF8C00, #FFD700)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}>
                      {experienceData.position}
                    </h2>

                    <h3 style={{
                      fontSize: isMobile ? '18px' : '24px',
                      fontWeight: '600',
                      marginBottom: '15px',
                      color: 'white',
                      opacity: '0.9'
                    }}>
                      {experienceData.company}
                    </h3>

                    <div style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: isMobile ? '16px' : '18px',
                      background: 'linear-gradient(135deg, #FFA500, #FF8C00)',
                      color: 'white',
                      padding: '12px 24px',
                      borderRadius: '25px',
                      boxShadow: '0 5px 15px rgba(255, 140, 0, 0.3)',
                      fontWeight: '600'
                    }}>
                      <SlCalender style={{ fontSize: '20px', marginRight: '10px' }} />
                      {experienceData.duration}
                    </div>
                  </div>

                  {/* Projects - Bullet Style */}
                  <div style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    padding: '0 20px'
                  }}>
                    <h3 style={{
                      fontSize: isMobile ? '20px' : '24px',
                      fontWeight: '700',
                      marginBottom: '30px',
                      textAlign: 'center',
                      color: 'white'
                    }}>
                      Projects Developed
                    </h3>

                    {experienceData.projects.map((project, index) => (
                      <div key={index} style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: isMobile ? '20px' : '25px',
                        padding: '0'
                      }}>
                        {/* Custom Bullet */}
                        <div style={{
                          minWidth: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                          marginRight: '12px',
                          marginTop: '8px',
                          boxShadow: '0 2px 8px rgba(255, 165, 0, 0.3)'
                        }}></div>

                        {/* Project Content */}
                        <div style={{ flex: 1 }}>
                          <span style={{
                            fontSize: isMobile ? '16px' : '18px',
                            lineHeight: '1.6',
                            color: '#ccc',
                            textAlign: 'left',
                            display: 'block'
                          }}>
                            <span style={{
                              fontWeight: '700',
                              fontSize: isMobile ? '18px' : '22px',
                              background: 'linear-gradient(45deg, #FF8C00, #FFD700)',
                              WebkitBackgroundClip: 'text',
                              WebkitTextFillColor: 'transparent',
                              backgroundClip: 'text'
                            }}>
                              {project.name}:
                            </span>
                            {' ' + project.description}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Education Section */}
              <div
                className={
                  toggleState === 2
                    ? "qualification_content qualification_content-active"
                    : "qualification_content"
                }
              >
                {educationItems.map((item, index) =>
                  isMobile ? (
                    <div className="qualification_data" key={index}>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.educationName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.educationInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.educationYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "20px", marginBottom: "50px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.educationCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                    </div>
                  ) : index % 2 === 0 ? (
                    <div className="qualification_data" key={index}>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.educationName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.educationInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.educationYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "10px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.educationCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                    </div>
                  ) : (
                    <div className="qualification_data" key={index}>
                      <div></div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.educationName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.educationInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.educationYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "10px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.educationCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>

              {/* Courses Section */}
              <div
                className={
                  toggleState === 3
                    ? "qualification_content qualification_content-active"
                    : "qualification_content"
                }
              >
                {courseItems.map((item, index) =>
                  isMobile ? (
                    <div className="qualification_data" key={index} style={{ gridTemplateColumns: "1fr 20fr" }}>
                      <div>
                        <span className="qualification_rounder" style={{ display: "block" }}></span>
                        <span className="qualification_line"></span>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <h3 className="qualification_title" style={{ maxWidth: "300px" }}>
                          {item?.data.courseName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.courseInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.courseYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "20px", marginBottom: "50px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.courseCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : index % 2 === 0 ? (
                    <div className="qualification_data" key={index}>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.courseName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.courseInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.courseYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "10px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.courseCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                    </div>
                  ) : (
                    <div className="qualification_data" key={index}>
                      <div></div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.courseName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.courseInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.courseYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "10px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.courseCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>

              {/* Volunteering Section */}
              <div
                className={
                  toggleState === 4
                    ? "qualification_content qualification_content-active"
                    : "qualification_content"
                }
              >
                {volunteeringItems.map((item, index) =>
                  isMobile ? (
                    <div className="qualification_data" key={index}>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.volunteeringName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.volunteeringInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.volunteeringYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "20px", marginBottom: "50px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.volunteeringCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                    </div>
                  ) : index % 2 === 0 ? (
                    <div className="qualification_data" key={index}>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.volunteeringName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.volunteeringInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.volunteeringYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "10px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.volunteeringCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                    </div>
                  ) : (
                    <div className="qualification_data" key={index}>
                      <div></div>
                      <div>
                        <span className="qualification_rounder"></span>
                        <span className="qualification_line"></span>
                      </div>
                      <div>
                        <h3 className="qualification_title">
                          {item?.data.volunteeringName}
                        </h3>
                        <span className="qualification_subtitle">
                          {item?.data.volunteeringInstitute}
                        </span>
                        <div className="qualification_calendar">
                          <SlCalender
                            style={{ fontSize: "20px", marginRight: "10px" }}
                          />
                          {item?.data.volunteeringYear}
                        </div>
                        <div className="qualification_certificates" style={{ marginTop: "10px", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleImageClick(item?.data.volunteeringCertificates)}>
                          CERTIFICATES
                          <LiaCertificateSolid
                            style={{ fontSize: "30px", marginRight: "10px" }}
                          />
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {openFullScreenImage && (
        <DisplayImageSlider
          onClose={() => setOpenFullScreenImage(false)}
          images={selectedImages}
        />
      )}
      <img className="background-image-left-qualification" src={colorSharp} alt="Image" />
      <img className="background-image-right-qualification" src={colorSharp2} alt="Image" />
    </section>
  );
};

export default Qualification;